import React, { useState } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { TextFieldWrapper } from '.';

const PlacesAutofcompleteWrapper = ({
  name = '',
  onInput = () => {},
  onChange = () => {},
  onBlur = () => {},
  placeholder = 'Search Location',
  error,
  helperText,
  value = '',
}) => {
  const [address, setAddress] = useState('');

  const handleChangeAddress = (newAddress) => {
    onChange(newAddress, null);
    onBlur();
  };

  const handleSelectAddress = (newAddress) => {
    geocodeByAddress(newAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        onInput(latLng);
        onChange(newAddress, latLng);
        onBlur();
      })
      .catch((error) => console.error('Error', error));
  };
  return (
    <PlacesAutocomplete
      value={value}
      onChange={handleChangeAddress}
      onSelect={handleSelectAddress}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={{ position: 'relative' }} className="w-100">
          <TextFieldWrapper
            {...getInputProps({
              //className: 'form-control',
              type: 'text',
              placeholder,
              name,
              error,
              helperText,
              fullWidth: true,
              onBlur: () => {
                onBlur();
              },
            })}
          />
          {loading ||
            (Array.isArray(suggestions) && suggestions.length > 0 && (
              <div
                className="autocomplete-dropdown-container w-100"
                style={{
                  position: 'absolute',
                  border: '1px solid #999',
                  borderRadius: '5px',
                  backgroundColor: '#fff',
                  zIndex: 999,
                  overflow: 'hidden',
                }}
              >
                {loading && <div>Loading...</div>}
                {suggestions.map((suggestion, index) => {
                  const className = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: '#86b7fe', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' };

                  const { key, ...itemProps } = getSuggestionItemProps(
                    suggestion,
                    {
                      className: className + ' p-1',
                      style,
                    }
                  );

                  return (
                    <div key={suggestion.placeId} {...itemProps}>
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            ))}
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default PlacesAutofcompleteWrapper;
